import { MYNAVI_PRIMARY } from '@/components/Campaign/mynavi/Color'
import { MyNaviButton } from '@/components/Campaign/mynavi/MyNaviButton/MyNaviButton'
import { MyNaviTypography } from '@/components/Campaign/mynavi/MyNaviUI/MyNaviTypography'
import { Dialog } from '@/components/UI/Dialog'

type Props = {
  opened: boolean
  onClose: () => void
}

export const DialogEmailComplete = ({ opened, onClose }: Props) => {
  return (
    <Dialog selectorState={opened} showCloseButton={false} closeOnClickOutside={false} closeFunc={onClose} lockScroll>
      <div className="flex flex-col items-center gap-4 px-2 pb-4">
        <MyNaviTypography variant="dialog-title" as="p" className="text-center m-0" style={{ color: MYNAVI_PRIMARY }}>
          登録完了
        </MyNaviTypography>
        <MyNaviTypography variant="subheading" as="p" className="text-center m-0">
          メールアドレスの登録が完了しました。
        </MyNaviTypography>
        <MyNaviButton label="閉じる" showIcon={false} onClick={onClose} />
      </div>
    </Dialog>
  )
}
